import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { library } from '@fortawesome/fontawesome-svg-core';
import _get from 'lodash/get';
import _keys from 'lodash/keys';
import _values from 'lodash/values';
import { iconLibraries, fontAwesomeIconMap, fishermanIconMap } from './Icon.constants';
export function initializeFontAwesomeLibrary() {
  library.add.apply(library, _toConsumableArray(_values(fontAwesomeIconMap)));
}
export function getLibraryFromIconName() {
  var iconName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var iconNamedLowered = iconName.toLowerCase();
  if (_keys(fontAwesomeIconMap).includes(iconNamedLowered)) {
    return iconLibraries.FontAwesome;
  }
  if (_keys(fishermanIconMap).includes(iconNamedLowered)) {
    return iconLibraries.Fisherman;
  }
  return iconLibraries.SemanticUI;
}
export function getFontAwesomeIcon() {
  var iconName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return _get(fontAwesomeIconMap, iconName.toLowerCase());
}
export function getFishermanIcon() {
  var iconName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return _get(fishermanIconMap, iconName.toLowerCase());
}